import ContentAdapter from 'rise-ui/adapters/apis/rise-api/content.js';

import { FetchOnce } from 'rise-ui/utils/adapter.js';

@FetchOnce()
export default class HelpPageAdapter extends ContentAdapter {
  pathForType() {
    return 'help_topic_page';
  }
}
